import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import BuildingPermit from './BuildingPermit'
import useBuildingPermit from './useBuildingPermit'
import { SDOutlineButton, SpacingWrapper } from '@/shared/theme/styled-components'

const BuildingPermitModal = () => {
  const { t, hidden, isOpen, openModal, closeModal } = useBuildingPermit()

  if (hidden) return null

  return (
    <SpacingWrapper $marginTop='1rem'>
      {/* @ts-ignore */}
      <SDOutlineButton onClick={openModal}>
        {t('subscriptionForm:address_module.building_permit_fields.title')}
      </SDOutlineButton>

      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={t('subscriptionForm:address_module.building_permit_fields.title')}
        sections={<BuildingPermit />}
      />
    </SpacingWrapper>
  )
}

export default BuildingPermitModal
